export default __webpack_public_path__ + "static/media/server-config.8ccc153a.svg";